import { useState } from 'react'

const ALPHA_CODE = 'CROSSBET2025'

export default function AlphaGate({ onUnlock }) {
  const [code, setCode] = useState('')
  const [error, setError] = useState(false)
  const [shake, setShake] = useState(false)

  const handleSubmit = () => {
    if (code.toUpperCase() === ALPHA_CODE) {
      localStorage.setItem('crossbet_alpha', '1')
      onUnlock()
    } else {
      setError(true)
      setShake(true)
      setTimeout(() => setShake(false), 600)
      setTimeout(() => setError(false), 2000)
    }
  }

  return (
    <div style={s.screen}>
      <div style={s.center}>
        <div style={{ ...s.box, animation: shake ? 'shake 0.5s' : 'none' }}>
          <input
            style={{ ...s.input, borderColor: error ? '#C0392B' : '#333' }}
            placeholder="Enter access code"
            value={code}
            onChange={e => setCode(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            autoFocus
          />
          {error && <div style={s.error}>Invalid code</div>}
          <button style={s.btn} onClick={handleSubmit}>→</button>
        </div>
      </div>
      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0) }
          20% { transform: translateX(-8px) }
          40% { transform: translateX(8px) }
          60% { transform: translateX(-8px) }
          80% { transform: translateX(8px) }
        }
      `}</style>
    </div>
  )
}

const s = {
  screen: { minHeight: '100vh', background: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  center: { width: '100%', maxWidth: 320, padding: '0 24px' },
  box: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 },
  icon: { fontSize: 32, color: '#C19A6B', fontFamily: 'serif' },
  input: { width: '100%', background: '#1A1A1A', border: '1px solid #444', borderRadius: 10, padding: '14px 16px', fontSize: 15, color: '#FDF9E7', fontFamily: 'inherit', outline: 'none', textAlign: 'center', letterSpacing: 3, boxSizing: 'border-box' },
  error: { fontSize: 12, color: '#C0392B' },
  btn: { background: '#C19A6B', border: 'none', borderRadius: 10, padding: '12px 32px', fontSize: 18, color: '#0A0A0A', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
}
